import { forwardRef } from 'react';

import { Checkbox as ChakraCheckbox } from '@chakra-ui/react';

import { CheckboxProps } from './checkbox.props';

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(props, ref) {
    const { icon, children, inputProps, rootRef, ...rest } = props;

    return (
        <ChakraCheckbox.Root ref={rootRef} {...rest}>
            <ChakraCheckbox.HiddenInput ref={ref} {...inputProps} />
            <ChakraCheckbox.Control>{icon || <ChakraCheckbox.Indicator />}</ChakraCheckbox.Control>
            {children ? <ChakraCheckbox.Label>{children}</ChakraCheckbox.Label> : undefined}
        </ChakraCheckbox.Root>
    );
});
